import { mapGetters } from "vuex";
import { openRegisterModal } from "../../topNavigation.js";

export default {
  props: {
    categories: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeMenuItem: null,
    };
  },
  methods: {
    setActiveMenuItem,
    openRegisterModal,
    getRouterLink,
    trackLinkClick,
    getLinkObject,
    handleLinkClick,
    handleChildClick: function (data) {
      if (data.type === "COLLECTION") {
        this.$router.push({
          name: "CollectionWithCategory",
          params: {
            categoryName: data.parentName,
            collectionName: data.name,
            collectionId: data.id,
          },
          query: {
            sortBy: "created_at_asc",
            page: 1,
          },
        });
      } else if (data.type === "CATEGORY") {
        this.$router.push({
          path: `/${this.$utils.urlSafeString(data.parentName)}/${this.$utils.urlSafeString(data.name)}/${
            data.entity_id
          }/products`,
        });
      }

      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": data.name,
          "Page Type": data.type,
        },
      });
      this.$store.dispatch("navigation/hideSideBar");
    },
    handleCollectionClick: function (parentName, name, collectionId) {
      this.$router.push({
        name: "CollectionWithCategory",
        params: {
          categoryName: parentName,
          collectionName: name,
          collectionId: collectionId,
        },
      });
      this.$store.dispatch("navigation/hideSideBar");
      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": name,
          "Page Type": "collection",
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
};

function setActiveMenuItem(item) {
  if (item !== null) {
    const computedActiveItem = {
      ...item,
    };

    computedActiveItem.children_containers = computedActiveItem.children_containers.map((container) => {
      return computedActiveItem.container_direction === "GRID"
        ? {
            ...container,
            view_components: [
              {
                id: container.id,
                info: {
                  layout: "CATEGORY_LABEL",
                  text: container.name,
                },
              },
              ...container.view_components.map((component) => ({
                ...component,
                info: {
                  ...component.info,
                  parent_name: container.name,
                },
              })),
            ],
          }
        : container;
    });

    this.activeMenuItem = computedActiveItem;

    return;
  }

  this.activeMenuItem = item;
}

function getRouterLink(data, isContainer) {
  const url = isContainer
    ? `/${this.$utils.urlSafeString(data.name)}/${data.id}/products`
    : `/${this.$utils.urlSafeString(data.parentName)}/${this.$utils.urlSafeString(data.name)}/${data.id}/products`;

  return url;
}

function trackLinkClick(data) {
  this.$ma.trackEvent({
    action: "Navigation Click",
    properties: {
      "Page Title": data.name,
      "Page Type": data.type,
    },
  });
}

function getLinkObject(data, type) {
  if (type === "category") {
    return {
      id: data.id,
      name: data.info.text,
      parentName: data.info.text,
      type: "category",
    };
  } else if (type === "sub-category") {
    return {
      id: data.id,
      name: data.info.text,
      parentName: data.info.parent_name || this.activeMenuItem.name,
      type: "sub-category",
    };
  } else if (type === "collection") {
    return {
      id: data.id,
      name: data.info.text,
      parentName: data.info.parent_name || this.activeMenuItem.name,
      type: "collection",
    };
  }
}

function handleLinkClick(data) {
  this.trackLinkClick(data);
  this.$store.dispatch("navigation/hideSideBar");
}
